import { z } from 'zod';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** True for a real calendar date in `yyyy-MM-dd` form: `2026-02-30` or `2026-13-45` has the shape but is no date. */
const isCalendarDate = (value: string) => {
  const date = new Date(`${value}T00:00:00Z`);
  return !Number.isNaN(date.getTime()) && date.toISOString().startsWith(value);
};

/** A date as `yyyy-MM-dd` in a filter; anything else, or nothing, is no date. */
export const IsoDateFilter = z.string().regex(ISO_DATE).refine(isCalendarDate).nullable().optional().catch(null);
